import { DEAL_TYPE_LABELS } from "@/lib/format";
import type { DealType } from "@/lib/types";

export function DealTypeBadge({ dealType }: { dealType: DealType | null | undefined }) {
  if (!dealType) return <span className="text-[var(--color-text-tertiary)]">—</span>;

  const isCash = dealType === "cash_structure";
  return (
    <span
      className="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium tabular-nums"
      style={{
        color: isCash ? "var(--color-deal-cash)" : "var(--color-deal-sba)",
        backgroundColor: isCash ? "color-mix(in srgb, var(--color-deal-cash) 15%, transparent)" : "color-mix(in srgb, var(--color-deal-sba) 15%, transparent)",
      }}
    >
      {DEAL_TYPE_LABELS[dealType] ?? dealType}
    </span>
  );
}
